import React, { Fragment } from 'react'
import injectStyles from 'react-jss'
import { Link } from 'react-router-dom'

import ArrowRight from '../../../../Assets/Images/icons/arrowRight'
import { styles } from './styles'

const Breadcrumbs = ({ classes, icon, breadcrumbs }) => {
  return (
    <div className={classes.breadcrumbs}>
      <div className={classes.mainIcon}>{icon}</div>
      {breadcrumbs.map((breadcrumb, index) => {
        return (
          <Fragment>
            {breadcrumbs.length !== index + 1 ? (
              <Link to={breadcrumb.to} className={classes.breadcrumbsText}>
                {breadcrumb.text}
              </Link>
            ) : (
              <div className={classes.lastBreadcrumb}> {breadcrumb.text}</div>
            )}
            {breadcrumbs.length !== index + 1 ? (
              <div className={classes.arrow}>
                <ArrowRight />
              </div>
            ) : null}
          </Fragment>
        )
      })}
    </div>
  )
}

export default injectStyles(styles)(Breadcrumbs)
